import { api } from './api'
import type { User, AuthTokens, LoginCredentials } from '@/types'

interface LoginResponse { user: User; tokens: AuthTokens }

export const authService = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const { data } = await api.post<{ data: LoginResponse }>('/auth/login', credentials)
    return data.data
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout')
  },

  refresh: async (refreshToken: string): Promise<AuthTokens> => {
    const { data } = await api.post<{ data: AuthTokens }>('/auth/refresh', { refreshToken })
    return data.data
  },

  me: async (): Promise<User> => {
    const { data } = await api.get<{ data: User }>('/auth/me')
    return data.data
  },

  forgotPassword: async (email: string): Promise<void> => {
    await api.post('/auth/forgot-password', { email })
  },

  resetPassword: async (payload: { token: string; email: string; newPassword: string }): Promise<void> => {
    await api.post('/auth/reset-password', payload)
  },
}
